import { render } from "./SetTitle.vue?vue&type=template&id=d999eea6&scoped=true"
import script from "./SetTitle.vue?vue&type=script&lang=ts"
export * from "./SetTitle.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-d999eea6"

export default script